import { IReportingState } from '@/modules/reporting/store/state';
import { IRootState } from '@/store/state';
import { GetterTree } from 'vuex';
import Investment from '../../../models/Investment';
import { GeneratedReportDetails, Report, Notes, QueuedReport } from '../types';
import { Fund } from '../../fund/types';
import { PensionScheme } from '@/modules/pensionScheme/types';
import { AnalysisPensionScheme } from '../../costAnalysis/types';
import { SubFund } from '../../subFund/types';
import TimePeriod from '../../../models/TimePeriod';
/**
 * --------------------------------------------------
 *	Cost Analysis Getters
 * --------------------------------------------------
 **/
export const ReportingGetters: IReportingGetters = {
  loadingReportData: (state: IReportingState): boolean =>
    state.loadingReportData,
  rawHtml: (state: IReportingState): string => state.rawHtml,
  planType: (state: IReportingState): string => state.planType,
  reportSubType: (state: IReportingState): string => state.reportSubType,
  selectedReportingPeriod: (state: IReportingState): TimePeriod =>
    state.selectedReportingPeriod,
  isOrganisationWideExport: (state: IReportingState): boolean =>
    state.isOrganisationWideExport,
  selectedReportClient: (
    state: IReportingState
  ): AnalysisPensionScheme | SubFund | null => state.selectedReportClient,
  generatedReportDetails: (state: IReportingState): GeneratedReportDetails =>
    state.generatedReportDetails,
  reports: (state: IReportingState): Report[] => state.reports,
  comments: (state: IReportingState): Notes[] => state.comments,
  reportPensionSchemes: (state: IReportingState): Fund[] =>
    state.reportPensionSchemes,
  schemesHavingExposedSubFunds: (state: IReportingState): PensionScheme[] =>
    state.schemesHavingExposedSubFunds,
  exposedSubFunds: (state: IReportingState): SubFund[] => state.exposedSubFunds,
  queuedReports: (state: IReportingState): QueuedReport[] => state.queuedReports
};

/**
 * --------------------------------------------------
 *	Cost Analysis Getters Interface
 * --------------------------------------------------
 **/
export interface IReportingGetters
  extends GetterTree<IReportingState, IRootState> {
  loadingReportData(state: IReportingState): boolean;
  rawHtml(state: IReportingState): string;
  planType(state: IReportingState): string;
  reportSubType(state: IReportingState): string;
  selectedReportingPeriod(state: IReportingState): TimePeriod;
  isOrganisationWideExport(state: IReportingState): boolean;
  selectedReportClient(
    state: IReportingState
  ): AnalysisPensionScheme | SubFund | null;
  generatedReportDetails(state: IReportingState): GeneratedReportDetails;
  reports(state: IReportingState): Report[];
  comments(state: IReportingState): Notes[];
  reportPensionSchemes(state: IReportingState): Fund[];
  schemesHavingExposedSubFunds(state: IReportingState): PensionScheme[];
  queuedReports(state: IReportingState): QueuedReport[];
}
